// 正式
module.exports = {
  title: 'voltshare-web-app',
  baseUrl: '', // 正式项目地址
  baseApi: '', // 正式api请求地址
  pk:'pk_live_51IsUDRACObXSZo7MH938KqaTlC0FAmxcSHl1g9iM6WGVVXHZH65vofGmpwoDMX9RN5c1LlbTZ4PZaCI3RWsguvNH00h6L2EtzW',
  successUrl: "http://charging.voltshare.co.uk/#/success",
  processUrl:"https://charging.voltshare.io/#/process",
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static',
}
